/* eslint-disable */
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { DeviceState } from './state';

const defaultState: DeviceState = {
  deviceList: [],
  deviceSpecs: [],
  deviceSpecsList: [],
  deviceSpecsNew: {
    count: 1,
    next: '',
    previous: '',
    results: []
  }
};

export const deviceModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
